import type { IServices } from "app/pages/industry-analysis/overview/components/IndustryOverviewContext/IndustryOverviewContext";
import {
    getTableApiQueryParams,
    getSingleMetricApiQueryParams,
} from "app/pages/industry-analysis/overview/utils/tableApiUtils";
import { useEffect, useState } from "react";
import { useCurrentStateAndParams } from "@uirouter/react";

function useIndustryOverviewSingleMetricData<T>(props: {
    services: IServices;
    endpoint: string;
    overrideParams?: Record<string, string>;
}) {
    const { services, endpoint, overrideParams } = props;

    const [data, setData] = useState<T>(null);
    const [isLoading, setIsLoading] = useState(true);
    const { params } = useCurrentStateAndParams();
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            try {
                const apiParams = getSingleMetricApiQueryParams(services, {
                    ...params,
                    ...overrideParams,
                });
                const response = await services.fetchService.get<T>(endpoint, apiParams);
                setData(response);
            } catch (e) {
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [endpoint, overrideParams, services]);

    return {
        data,
        isLoading,
    };
}

export function useIndustryOverviewTableData<T>(props: {
    services: IServices;
    endpoint: string;
    overrideParams?: Record<string, string | number>;
}) {
    const { services, endpoint, overrideParams } = props;

    const [data, setData] = useState<T>(null);
    const [isLoading, setIsLoading] = useState(false);
    const { params } = useCurrentStateAndParams();

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);

            try {
                const apiParams = getTableApiQueryParams(services, {
                    ...params,
                    ...overrideParams,
                });
                const response = await services.fetchService.get<T>(endpoint, apiParams);
                setData(response);
            } catch (e) {
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [endpoint, overrideParams, services]);

    return {
        data,
        isLoading,
    };
}
